(() => {
  const ROOT_SELECTOR = '[data-ld-return-system]';
  const REASON_VALUES = {
    'ripensamento': 'Recesso per ripensamento',
    'in-transito': 'Ordine in produzione o in transito',
    'danneggiato': 'Prodotto danneggiato o rotto',
    'errato-mancante': 'Prodotto errato o mancante',
    'non-arrivato': 'Pacco non arrivato',
    'sicurezza': 'Reazione indesiderata o sicurezza'
  };

  const normalizeReason = (value) => Object.prototype.hasOwnProperty.call(REASON_VALUES, value) ? value : '';

  const applyReason = (form, reason) => {
    if (!form) return;
    const normalized = normalizeReason(reason);
    const reasonField = form.querySelector('[data-ld-return-reason]');
    const typeField = form.querySelector('[data-ld-return-request-type]');
    const solutionField = form.querySelector('[data-ld-return-solution]');

    if (normalized && reasonField) reasonField.value = REASON_VALUES[normalized];

    const isWithdrawal = normalized === 'ripensamento' || normalized === 'in-transito';
    if (typeField) typeField.value = isWithdrawal ? 'Recesso e rimborso' : 'Assistenza post-vendita';

    if (isWithdrawal && solutionField && !solutionField.value) {
      solutionField.value = 'Rimborso per recesso';
    }
  };

  const syncRequestType = (form) => {
    if (!form) return;
    const reasonField = form.querySelector('[data-ld-return-reason]');
    const typeField = form.querySelector('[data-ld-return-request-type]');
    if (!reasonField || !typeField) return;
    const isWithdrawal = reasonField.value === REASON_VALUES.ripensamento || reasonField.value === REASON_VALUES['in-transito'];
    typeField.value = isWithdrawal ? 'Recesso e rimborso' : 'Assistenza post-vendita';
  };

  const openDialog = (dialog, trigger) => {
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    const root = trigger.closest(ROOT_SELECTOR) || document;
    const form = root.querySelector('.ld-withdrawal__form') || document.querySelector('.ld-withdrawal__form');
    applyReason(form, trigger.dataset.ldReturnReason || '');
    dialog.showModal();
    return true;
  };

  const initRoot = (root) => {
    if (!root || root.dataset.ldReturnReady === 'true') return;
    root.dataset.ldReturnReady = 'true';

    root.querySelectorAll('[data-ld-return-reason]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const form = root.querySelector('.ld-withdrawal__form') || document.querySelector('.ld-withdrawal__form');
        applyReason(form, trigger.dataset.ldReturnReason || '');
      });
    });

    root.querySelectorAll('[data-ld-return-open]').forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        const targetId = trigger.getAttribute('data-ld-return-open');
        const dialog = targetId ? document.getElementById(targetId) : null;
        if (openDialog(dialog, trigger)) event.preventDefault();
      });
    });

    root.querySelectorAll('[data-ld-return-close]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const dialog = trigger.closest('dialog');
        if (dialog) dialog.close();
      });
    });

    root.querySelectorAll('dialog').forEach((dialog) => {
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    });

    root.querySelectorAll('.ld-withdrawal__form').forEach((form) => {
      const reasonField = form.querySelector('[data-ld-return-reason]');
      if (reasonField) reasonField.addEventListener('change', () => syncRequestType(form));
    });
  };

  const fillField = (form, selector, value, maxLength = 250) => {
    const field = form.querySelector(selector);
    if (field && value) field.value = value.slice(0, maxLength);
  };

  const initPagePrefill = () => {
    const form = document.querySelector('.ld-withdrawal__form');
    if (!form || form.dataset.ldReturnPrefilled === 'true') return;
    form.dataset.ldReturnPrefilled = 'true';

    const params = new URLSearchParams(window.location.search);
    const reason = normalizeReason(params.get('reason'));

    applyReason(form, reason);
    fillField(form, '[data-ld-return-product]', params.get('product') || '', 180);
    fillField(form, '[data-ld-return-product-handle]', params.get('product_handle') || '', 180);
    fillField(form, '[data-ld-return-product-id]', params.get('product_id') || '', 80);
    fillField(form, '[data-ld-return-variant]', params.get('variant') || '', 180);
    fillField(form, '[data-ld-return-variant-id]', params.get('variant_id') || '', 80);
    fillField(form, '[data-ld-return-source]', params.get('source') || '', 500);

  };

  const initAll = (scope = document) => {
    scope.querySelectorAll(ROOT_SELECTOR).forEach(initRoot);
    if (scope.matches?.(ROOT_SELECTOR)) initRoot(scope);
    initPagePrefill();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
